import { useNavigate } from 'react-router-dom';
import './Pages.css';

export default function Cancel() {
  const navigate = useNavigate();
  return (
    <div className="page-wrap">
      <div className="page-card fade-up">
        <div className="page-icon">😔</div>
        <h2>Payment cancelled</h2>
        <p>No charge was made. Your tailored CV is still waiting — you can pay and download anytime.</p>
        <button className="page-btn" onClick={() => navigate(-1)}>
          Go back
        </button>
        <button className="page-btn-secondary" onClick={() => navigate('/')}>
          Start over
        </button>
      </div>
    </div>
  );
}
